var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticStyle:{"height":"20px"}}),_c('Title'),_c('HomeTask')],1)}
var staticRenderFns = []

export { render, staticRenderFns }